define('taoQtiItem/qtiItem/core/choices/TextEntry',['taoQtiItem/qtiItem/core/choices/TextVariableChoice'], function(QtiTextVariableChoice){
    var QtiTextEntry = QtiTextVariableChoice.extend({
        qtiClass : 'textEntry'
    });
    return QtiTextEntry;
});



